export enum ActionType {
	CAMERA_FETCH_INFO = 'CAMERA_FETCH_INFO',
	COMMANDS_FETCH_INFO = 'COMMANDS_FETCH_INFO',
	MULTIMEDIA_OPEN_BY_DATE = 'MULTIMEDIA_OPEN_BY_DATE',
	MULTIMEDIA_OPEN_BY_TRACKING_HISTORY_ID = 'MULTIMEDIA_OPEN_BY_TRACKING_HISTORY_ID',
	MULTIMEDIA_CLOSE_MODAL = 'MULTIMEDIA_CLOSE_MODAL',
	MULTIMEDIA_UPDATE_UTC_DATE = 'MULTIMEDIA_UPDATE_UTC_DATE',
	MULTIMEDIA_CLEAR_REFHESH_DATA = 'MULTIMEDIA_CLEAR_REFHESH_DATA',
	MULTIMEDIA_CLEAR_CHANNEL_KEY = 'MULTIMEDIA_CLEAR_CHANNEL_KEY',
	MULTIMEDIA_REQUEST_LOADING = 'MULTIMEDIA_REQUEST_LOADING',
	UPDATE_DEVICE_EVENT = 'UPDATE_DEVICE_EVENT',
	GROUPS_FETCH_INFO = 'GROUPS_FETCH_INFO',
	GROUPS_ADD = 'GROUPS_ADD',
	GROUPS_EDIT = 'GROUPS_EDIT',
	GROUPS_DELETE = 'GROUPS_DELETE',
	GROUPS_FETCH_DEVICES = 'GROUPS_FETCH_DEVICES',
	GROUPS_FETCH_ACCOUNTS = 'GROUPS_FETCH_ACCOUNTS',
	GROUPS_UN_SHARE = 'GROUPS_UN_SHARE',
	LOADING_TRACE = 'LOADING_TRACE',
	GOOGLE_LOADED = 'GOOGLE_LOADED',
	CLEAN_REDUCER = 'CLEAN_REDUCER',
	LOG_OUT = 'LOG_OUT',
	USER_UPDATE_PROFILE = 'USER_UPDATE_PROFILE',
	TWO_FACTOR_AUTH_STATUS = 'TWO_FACTOR_AUTH_STATUS',
	UPDATE_DEVICE = 'UPDATE_DEVICE',
	MAP_DEVICES_SET_DEVICES = 'MAP_DEVICES_SET_DEVICES',
	MAP_DEVICES_UPDATE_DEVICE = 'MAP_DEVICES_UPDATE_DEVICE',
	MAP_DEVICES_UPDATE_LAST_REPORT = 'MAP_DEVICES_UPDATE_LAST_REPORT',
	MAP_DEVICES_CLEAR_DEVICES = 'MAP_DEVICES_CLEAR_DEVICES',
	MAP_DEVICES_SET_SELECTED_GROUPS = 'MAP_DEVICES_SET_SELECTED_GROUPS',
	MAP_DEVICES_SET_SELECTED_UNIT = 'MAP_DEVICES_SET_SELECTED_UNIT',
	MAP_DEVICES_SET_SELECTED_GROUP_CHILD = 'MAP_DEVICES_SET_SELECTED_GROUP_CHILD',
	MAP_DEVICES_REMOVE_SELECTED_GROUP = 'MAP_DEVICES_REMOVE_SELECTED_GROUP',
	MAP_DEVICES_REMOVE_SELECTED_GROUP_CHILD = 'MAP_DEVICES_REMOVE_SELECTED_GROUP_CHILD',
	MAP_DEVICES_CLEAR_ALL_DATA = 'MAP_DEVICES_CLEAR_DEVICES_ALL_DATA',
	MAP_DEVICES_SET_LOADING_STATUS = 'MAP_DEVICES_SET_LOADING_STATUS',
	MAP_DEVICES_SET_LOADING_SEGMENTED_TRAIL = 'MAP_DEVICES_SET_LOADING_SEGMENTED_TRAIL',
	MAP_DEVICES_SET_LAST_EVENTS = 'MAP_DEVICES_SET_LAST_EVENTS',
	MAP_DEVICES_SET_SELECTED_DATE = 'MAP_DEVICES_SET_SELECTED_DATE',
	MAP_DEVICES_UPDATE_TRAIL_DATA = 'MAP_DEVICES_UPDATE_TRAIL_DATA',
	MAP_DEVICES_UPDATE_HISTORICAL_MARKER = 'MAP_DEVICES_UPDATE_HISTORICAL_MARKER',
	MAP_DEVICES_UPDATE_DEVICE_PROPERTIES = 'MAP_DEVICES_UPDATE_DEVICE_PROPERTIES',
	COMPANY_FETCH_ROLES = 'COMPANY_FETCH_ROLES',
	TERRA_DRAW_SET_IS_PANEL_ACTIVE = 'TERRA_DRAW_SET_IS_PANEL_ACTIVE',
	TERRA_DRAW_SET_SELECTED_FEATURES = 'TERRA_DRAW_SET_SELECTED_FEATURES',
	TERRA_DRAW_SET_FEATURE = 'TERRA_DRAW_SET_FEATURE',
	TERRA_DRAW_SET_COLOR = 'TERRA_DRAW_SET_COLOR',
	TERRA_DRAW_CLEAR = 'TERRA_DRAW_CLEAR',
	TERRA_DRAW_RESET = 'TERRA_DRAW_RESET',
}

export interface IAction<T = undefined> {
	type: ActionType;
	payload?: T;
}

export interface CleanReducerAction extends IAction<undefined> {
	type: ActionType.CLEAN_REDUCER;
}
export interface LogOutAction extends IAction<undefined> {
	type: ActionType.LOG_OUT;
}
